<template>
<section class="">
<div class="grid grid-cols-3 md:grid-cols-7">
    <nuxt-img v-for="(image, index) in reviewImages" sizes="xs:105px sm:142px md:221px lg:169px xl:193" :key="index" 
        :src="image.src" :width="image.width" :height="image.height" 
        :alt="image.alt" :class="index === reviewImages.length - 1 ? 'col-span-1 w-full h-full hidden md:block' : 'col-span-1 w-full h-full'" loading="lazy" format="webp" />
</div>
</section>
</template>

<script setup>
defineProps({
  reviewImages: {
    type: Array,
    default: () => [
      {
        src: '/assets/images/review-decaf-1-new.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 1'
      },
      {
        src: '/assets/images/review-decaf-2-new.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 2'
      },
      {
        src: '/assets/images/review-decaf-3.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 3'
      },
      {
        src: '/assets/images/review-decaf-4.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 4'
      },
      {
        src: '/assets/images/review-decaf-5.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 5'
      },
      {
        src: '/assets/images/review-decaf-9-new.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 6'
      },
      {
        src: '/assets/images/review-decaf-10.jpg',
        width: 205,
        height: 316,
        alt: 'Customer Review 7'
      }
    ]
  }
})

defineBuilderComponent({
    friendlyName: 'ImageReviewsGallery',
    canHaveChildren: false,
    inputs: [
        {
            name: 'reviewImages',
            type: 'list',
            subFields: [
                {
                    name: 'src',
                    type: 'file'
                },
                {
                    name: 'width',
                    type: 'number'
                },
                {
                    name: 'height',
                    type: 'number'
                },
                {
                    name: 'alt',
                    type: 'text'
                }
            ],
            defaultValue: [
                {
                    src: '/assets/images/review-decaf-1-new.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 1'
                },
                {
                    src: '/assets/images/review-decaf-2-new.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 2'
                },
                {
                    src: '/assets/images/review-decaf-3.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 3'
                },
                {
                    src: '/assets/images/review-decaf-4.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 4'
                },
                {
                    src: '/assets/images/review-decaf-5.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 5'
                },
                {
                    src: '/assets/images/review-decaf-9-new.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 6'
                },
                {
                    src: '/assets/images/review-decaf-10.jpg',
                    width: 205,
                    height: 316,
                    alt: 'Customer Review 7'
                }
            ]
        }
    ]
})
</script>